import { IDashboardStats } from "../../models/DashboardStats";
import DashboardTile from "./DashboardTile";

interface IVehicleDismantlingListsTableProps {
  dashboardStats: IDashboardStats | undefined;
  span?: 1 | 2;
}

type DashboardStatsExtended = IDashboardStats & {
  totalVehiclesOnsite?: number;
  vehiclesAwaitingDismantlingLists?: number;
  vehiclesWithDismantlingLists?: number;
  totalPartsAwaitingRemoval?: number;
  totalEnginesAwaitingRemoval?: number;
};

const rowConfig: {
  key: keyof DashboardStatsExtended;
  label: string;
  bgClass: string;
  textClass: string;
  noData?: boolean;
}[] = [
  { key: "totalVehiclesOnsite", label: "Total Number Vehicles Onsite", bgClass: "bg-slate-50", textClass: "text-slate-700", noData: true },
  { key: "vehiclesAwaitingDismantlingLists", label: "Collected Vehicles Awaiting Jobs", bgClass: "bg-amber-50", textClass: "text-amber-700" },
  { key: "vehiclesWithDismantlingLists", label: "Vehicles With Unscheduled Jobs", bgClass: "bg-green-50", textClass: "text-green-700" },
  { key: "totalPartsAwaitingRemoval", label: "Parts Awaiting Removal", bgClass: "bg-sky-50", textClass: "text-sky-700" },
  { key: "totalEnginesAwaitingRemoval", label: "Engines Awaiting Removal", bgClass: "bg-fuchsia-50", textClass: "text-fuchsia-700" },
];

function formatValue(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return "—";
  return String(value);
}

export default function VehicleDismantlingListsTable({ dashboardStats, span = 2 }: IVehicleDismantlingListsTableProps) {
  if (!dashboardStats) return null;

  const stats = dashboardStats as DashboardStatsExtended;

  return (
    <DashboardTile span={span}>
      <div className="p-3">
        <div className="mb-3 w-full">
          <h3 className="prose font-semibold text-gray-900">Vehicle Dismantling Lists</h3>
          <p className="text-sm text-gray-500 mt-0.5">Unscheduled jobs status at a glance</p>
        </div>

        <div className="mt-4 overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
          <table className="w-full border-collapse text-left text-base">
            <thead>
              <tr className="bg-gray-100 border-b border-gray-200">
                <th className="pb-2.5 pt-2.5 pl-4 pr-4 font-semibold text-gray-800">Metric</th>
                <th className="pb-2.5 pt-2.5 pr-4 text-right font-semibold text-gray-800">Value</th>
              </tr>
            </thead>
            <tbody>
              {rowConfig.map(({ key, label, bgClass, textClass, noData }) => {
                const value = stats[key] as number | null | undefined;
                return (
                  <tr key={String(key)} className={`font-medium transition-colors ${bgClass}`}>
                    <td className={`py-2.5 pl-4 pr-4 ${textClass}`}>{label}</td>
                    <td className={`py-2.5 pr-4 text-right font-bold ${textClass}`}>{noData ? "—" : formatValue(value)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardTile>
  );
}
